var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Airplane02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Airplane02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Airplane02-2",
    "data-name": "Airplane02"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.8487,440.1385h-1.5922a15.7663,15.7663,0,0,1-15.7206-15.7073l.0066-29.679,46.8122-27.568a66.2658,66.2658,0,0,1-1.35-13.1166l-2.5431-62.65L83.2691,329.7552H81.8527a17.6184,17.6184,0,0,1-17.5988-17.596V267.7771L211.93,188.1434,209.65,119.7747c0-26.42,20.5646-47.9132,45.8413-47.9132,25.28,0,45.8423,21.4928,45.8423,47.9132l-.0067.3326-2.2515,67.4974L447.7461,267.781v44.3782a17.6135,17.6135,0,0,1-17.593,17.596h-1.4165l-133.209-38.6328-2.56,62.9423a65.6262,65.6262,0,0,1-1.2407,12.5818l47.7375,28.1057-.0066,29.6657a15.7228,15.7228,0,0,1-15.7244,15.7177h-1.5894l-63.9026-20.8848h-4.4993Zm2.64-33.9815-.0028,12.13L250.57,399.298h10.8528l58.0915,18.9858.0029-12.1268-51.4311-30.2736,2.62-7.6912a44.3734,44.3734,0,0,0,2.3113-14.3375l.01-.4056,3.6015-88.5742,151.164,43.8368V279.6911L278.7192,199.2926l2.6639-79.6737c-.077-15.3482-11.6642-27.8074-25.8923-27.8074S229.6755,104.2736,229.6,119.6189l2.6828,80.2152L84.2039,279.6873v29.0234l150.157-43.547,3.5977,88.6806a44.3807,44.3807,0,0,0,2.4471,14.7535l2.7227,7.7435Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.43c9f50b8683c2055229101dc01b7193.svg";
export { ForwardRef as ReactComponent };